import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// FastAPI answers some gates with a structured detail — {message, paperwork} for the vendor
// paperwork gate, {message, blockers} for an invoice, {message, punch, can_force} for a
// completion. Handing that object straight to a toast crashes React ("Objects are not valid as
// a React child") and takes the whole page with it. Always render through this.
export const errMsg = (e, fallback = "Something went wrong — try again") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string" && d.trim()) return d;
  if (d && typeof d === "object") {
    if (typeof d.message === "string" && d.message.trim()) return d.message;
    if (Array.isArray(d) && typeof d[0]?.msg === "string") return d[0].msg;
  }
  return fallback;
};
